import { render } from "./EditPromotionModal.vue?vue&type=template&id=00f88273"
import script from "./EditPromotionModal.vue?vue&type=script&lang=js"
export * from "./EditPromotionModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__